import { LogLevel } from '@azure/msal-browser';
import { environment } from './environments/environment';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

interface AuthConfig {
    clientId: string;
    authority: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    navigateToLoginRequestUrl: boolean;
}

interface CacheConfig {
    cacheLocation: 'localStorage' | 'sessionStorage';
    storeAuthStateInCookie: boolean;
}

interface LoggerOptions {
    loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => void;
}

interface SystemConfig {
    loggerOptions: LoggerOptions;
}

interface MsalConfig {
    auth: AuthConfig;
    cache: CacheConfig;
    system: SystemConfig;
}

export const msalConfig: MsalConfig = {
    auth: {
        clientId: environment.msalConfig.clientId,
        authority: environment.msalConfig.authority,
        redirectUri: environment.msalConfig.redirectUri,
        postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', 
        storeAuthStateInCookie: false, 
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};
